import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { MissionIcon } from '@repo/ui/icons'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { getMissionType } from '../../../api/mission-types/get-mission-type'
import { updateMissionType } from '../../../api/mission-types/update-mission-type'
import { ItemNotFound } from '../../../components/elements/item-not-found'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import UserNavBar from '../../../components/elements/nav-bar'
import { MissionTypeForm } from '../../../components/pages/mission-type/mission-type-form'
import { Paths } from '../../../lib/constants/path'
import { updateButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import NotFoundPage from '../../common/not-found'

export function MissionsUpdatePage() {
  const { id } = useParams<{ id: string }>()
  const { navigate, back } = useNavigator()
  const queryClient = useQueryClient()

  if (!id || isNaN(+id)) return <ItemNotFound title="Identifiant de type de mission invalide" />

  const { mutateAsync } = useMutation({
    mutationFn: updateMissionType,
    onError: showAxiosError,
    onSuccess() {
      queryClient.invalidateQueries({ exact: true, queryKey: ['mission-type', id] })
      toast.success('Type de mission modifié avec succès')
    }
  })

  const { data, isLoading } = useQuery({
    queryKey: ['mission-type', id],
    queryFn: () => getMissionType(+id)
  })

  if (isLoading) return <LoadingScreen />
  if (!data) return <NotFoundPage />

  return (
    <div>
      <UserNavBar title={'Modifier le type de mission'} icon={MissionIcon} />

      <div className={'h-4'} />

      <Box>
        <MissionTypeForm
          defaultValues={data}
          buttonsConfig={updateButtonsConfig({
            onCancel: () => back(Paths.MISSION_TYPE_LIST_PAGE),
            onUpdate: (values) => mutateAsync({ id: data.id, ...values }),
            onUpdateThenCreate: async (values) => {
              await mutateAsync({ id: data.id, ...values })
              navigate(Paths.MISSION_TYPE_CREATE_PAGE)
            },
            onUpdateThenList: async (values) => {
              await mutateAsync({ id: data.id, ...values })
              navigate(Paths.MISSION_TYPE_LIST_PAGE, { replace: true })
            }
          })}
        />
      </Box>
    </div>
  )
}
